<template>
  <span>
    <div>{{ formatDateTime(object.last_login_clinic_timezone) }}</div>
    <div class="text-muted small">{{ object.last_ip }}</div>
  </span>
</template>

<script setup>
import { formatDateTime } from "@/extensions/filters/filters"

defineProps({
  object: Object
})
</script>

<style scoped lang="scss">
  .doctor-img {
    border-radius: 100%;
    width: 36px;
    height: 36px;
    border-width: 3px;
    border-style: solid;
    border-color: #000;
  }
</style>
